import { useInfiniteQuery } from '@tanstack/react-query';

import { Clips } from '@air/api';
import { type ClipType, SortDirection } from '@air/api/types';
import { ONE_MINUTE } from '@air/utilities';

const PAGE_SIZE = 40;

export const BOARD_VERSION_ASSETS_QUERY_KEY = 'BOARD_VERSION_ASSETS';

type BoardVersionAssetsParams = {
  boardId: string | undefined;
  clipType: ClipType;
  workspaceId: string;
};

export const getBoardVersionAssetsKey = ({ boardId, clipType, workspaceId }: BoardVersionAssetsParams) =>
  [BOARD_VERSION_ASSETS_QUERY_KEY, { boardId, clipType, workspaceId }] as const;

export const useBoardVersionAssetsList = ({ boardId, clipType, workspaceId }: BoardVersionAssetsParams) =>
  useInfiniteQuery({
    getNextPageParam: (lastPage: Awaited<ReturnType<typeof Clips.search>>) => lastPage.pagination?.cursor ?? undefined,
    initialPageParam: '',
    queryFn: async ({ pageParam }) =>
      Clips.search({
        ...(boardId ? { boardId } : {}),
        cursor: pageParam || undefined,
        limit: PAGE_SIZE,
        sortField: { direction: SortDirection.desc, name: 'dateModified' },
        types: [clipType],
        workspaceId,
      }),
    queryKey: getBoardVersionAssetsKey({ boardId, clipType, workspaceId }),
    staleTime: ONE_MINUTE,
  });
